import * as yup from 'yup';

import { translations } from 'locales/i18n';

export const systemNotificationValidationSchema = t =>
  yup.object().shape({
    headline: yup.string().required(t(translations.validation.required())),
    content: yup.string().required(t(translations.validation.required())),
    startDate: yup
      .date()
      .required(t(translations.validation.required()))
      .typeError(t(translations.validation.required())),
    endDate: yup.date().nullable(),
    isActive: yup.boolean().required(t(translations.validation.required())),
    type: yup
      .string()
      .required(t(translations.validation.required()))
      .typeError(t(translations.validation.required()))
  });
